import AscDescSort from '../../../../UtilComponent/level_1/AscDescSort'
import SelectBox from '../../../../UtilComponent/level_1/SelectBox'

type Props = {
  selectedSort: any
  setSelectedSort: any
  options: any
  isAsc: any
  setIsAsc: any
}

const SortBox = (props: Props) => {
  const { selectedSort, setSelectedSort, options, isAsc, setIsAsc } = props

  const numbers = ['createdDate', 'updatedDate']

  return (
    <span>
      <SelectBox
        id="sort"
        autoComplete="none"
        label="並び替え"
        state={selectedSort}
        setState={setSelectedSort}
        options={options}
      />

      <AscDescSort
        selectedSort={selectedSort}
        numbers={numbers}
        isAsc={isAsc}
        setIsAsc={setIsAsc}
      />
    </span>
  )
}

export default SortBox
